/**
 * El diseño que alguien armó en la demo pública (`/demo`), esperando a que
 * tenga cuenta.
 *
 * La demo se usa sin sesión, y «Empezar con este diseño» lleva a registrarse:
 * entre medias puede haber un correo de confirmación o un viaje a Google y de
 * vuelta. Se guarda aquí, en este navegador —el mismo origen que el panel—, y
 * al entrar con sesión el panel abre el asistente con él (ver `Home`). No va
 * por usuario porque cuando se guarda todavía no hay ninguno.
 */
import type { CreateForm } from './preview/compose'

export type PendingDemoDesign = {
  savedAt: number
  form: CreateForm
}

/** Pasada una semana ya no se ofrece, como el borrador de la IA (`aiDraftStore`). */
const MAX_AGE_MS = 7 * 24 * 60 * 60 * 1000
const KEY = 'veltica:demo-design'

export function readDemoDesign(): PendingDemoDesign | null {
  try {
    const raw = globalThis.localStorage.getItem(KEY)
    if (!raw) return null
    const saved = JSON.parse(raw) as PendingDemoDesign
    if (!saved?.form || typeof saved.savedAt !== 'number' || Date.now() - saved.savedAt > MAX_AGE_MS) {
      globalThis.localStorage.removeItem(KEY)
      return null
    }
    return saved
  } catch {
    return null
  }
}

/** `false` si no se pudo guardar (navegación privada, almacenamiento lleno). */
export function saveDemoDesign(form: CreateForm): boolean {
  try {
    globalThis.localStorage.setItem(KEY, JSON.stringify({ form, savedAt: Date.now() }))
    return true
  } catch {
    return false
  }
}

export function clearDemoDesign(): void {
  try {
    globalThis.localStorage.removeItem(KEY)
  } catch {
    // Nada que limpiar si no hay almacenamiento.
  }
}
